import { styledWithTheme } from "../../context";
import { Col } from "../../layout";
import { getThemeSpace, LABEL_SPACING } from "../../utils";
export var LabelWrapperCol = styledWithTheme(Col)(function (_ref) {
  var theme = _ref.theme;
  return {
    alignItems: 'flex-start',
    gap: getThemeSpace(theme, LABEL_SPACING)
  };
});